import { useScopedField } from '@ngt/forms-core';
import { useEffect } from 'react';

const subscription = {
    value: true
};

const RegistrationTypeUpdater = () => {

    const {
        state: { value: defaultUser },
        context: { setValue: setDefaultUser }
    } = useScopedField<boolean>('defaultUser', subscription);

    const {
        state: { value: student },
        context: { setValue: setStudent }
    } = useScopedField<boolean>('student', subscription);

    const {
        state: { value: trialCoordinator },
        context: { setValue: setTrialCoordinator }
    } = useScopedField<boolean>('trialCoordinator', subscription);

    const {
        state: { value: registrar },
        context: { setValue: setRegistrar }
    } = useScopedField<boolean>('registrar', subscription);

    const {
        state: { value: staff },
        context: { setValue: setStaff }
    } = useScopedField<boolean>('staff', subscription);

    const {
        state: { value: attendeeFromJapanOrKorea },
        context: { setValue: setAttendeeFromJapanOrKorea }
    } = useScopedField<boolean>('attendeeFromJapanOrKorea', subscription);

    const {
        state: { value: registrationType },
        context: { setValue: setRegistrationType }
    } = useScopedField<number>('registrationType', subscription);

    useScopedField<boolean>('staffConfirmed', subscription);

    useEffect(() => {
        switch (registrationType) {
            case 1:
                setDefaultUser(true, true, true, true, false);
                setTrialCoordinator(false, true, true, true, false);
                setStudent(false, true, true, true, false);
                setRegistrar(false, true, true, true, false);
                setStaff(false, true, true, true, false);
                setAttendeeFromJapanOrKorea(false, true, true, true, false);
                break;
            case 2:
                setDefaultUser(false, true, true, true, false);
                setTrialCoordinator(false, true, true, true, false);
                setStudent(true, true, true, true, false);
                setRegistrar(false, true, true, true, false);
                setStaff(false, true, true, true, false);
                setAttendeeFromJapanOrKorea(false, true, true, true, false);
                break;
            case 3:
                setDefaultUser(false, true, true, true, false);
                setTrialCoordinator(true, true, true, true, false);
                setStudent(false, true, true, true, false);
                setRegistrar(false, true, true, true, false);
                setStaff(false, true, true, true, false);
                setAttendeeFromJapanOrKorea(false, true, true, true, false);
                break;
            case 4:
                setDefaultUser(false, true, true, true, false);
                setTrialCoordinator(false, true, true, true, false);
                setStudent(false, true, true, true, false);
                setRegistrar(true, true, true, true, false);
                setStaff(false, true, true, true, false);
                setAttendeeFromJapanOrKorea(false, true, true, true, false);
                break;
            case 5:
                setDefaultUser(false, true, true, true, false);
                setTrialCoordinator(false, true, true, true, false);
                setStudent(false, true, true, true, false);
                setRegistrar(false, true, true, true, false);
                setStaff(true, true, true, true, false);
                setAttendeeFromJapanOrKorea(false, true, true, true, false);
                break;
            case 6:
                setDefaultUser(false, true, true, true, false);
                setTrialCoordinator(false, true, true, true, false);
                setStudent(false, true, true, true, false);
                setRegistrar(false, true, true, true, false);
                setStaff(false, true, true, true, false);
                setAttendeeFromJapanOrKorea(true, true, true, true, false);
                break;
            default:
                setDefaultUser(true, true, true, true, false);
                setTrialCoordinator(false, true, true, true, false);
                setStudent(false, true, true, true, false);
                setRegistrar(false, true, true, true, false);
                setStaff(false, true, true, true, false);
                setAttendeeFromJapanOrKorea(false, true, true, true, false);
                break;
        }
    }, [registrationType]);

    useEffect(() => {
        if (trialCoordinator) {
            setRegistrationType(3, true, true, true, false);
            setStudent(false, true, true, true, false);
            setRegistrar(false, true, true, true, false);
            setStaff(false, true, true, true, false);
            setDefaultUser(false, true, true, true, false);
            setAttendeeFromJapanOrKorea(false, true, true, true, false);
        }
        else if (student) {
            setRegistrationType(2, true, true, true, false);
            setTrialCoordinator(false, true, true, true, false);
            setRegistrar(false, true, true, true, false);
            setStaff(false, true, true, true, false);
            setDefaultUser(false, true, true, true, false);
            setAttendeeFromJapanOrKorea(false, true, true, true, false);
        }
        else if (staff) {
            setRegistrationType(5, true, true, true, false);
            setStudent(false, true, true, true, false);
            setRegistrar(false, true, true, true, false);
            setTrialCoordinator(false, true, true, true, false);
            setDefaultUser(false, true, true, true, false);
            setAttendeeFromJapanOrKorea(false, true, true, true, false);
        }
        else if (registrar) {
            setRegistrationType(4, true, true, true, false);
            setStudent(false, true, true, true, false);
            setTrialCoordinator(false, true, true, true, false);
            setStaff(false, true, true, true, false);
            setDefaultUser(false, true, true, true, false);
            setAttendeeFromJapanOrKorea(false, true, true, true, false);
        }
        else if (attendeeFromJapanOrKorea) {
            setRegistrationType(6, true, true, true, false);
            setStudent(false, true, true, true, false);
            setTrialCoordinator(false, true, true, true, false);
            setStaff(false, true, true, true, false);
            setRegistrar(false, true, true, true, false);
            setDefaultUser(false, true, true, true, false);
        }
        else if (defaultUser) {
            setRegistrationType(1, true, true, true, false);
            setStudent(false, true, true, true, false);
            setTrialCoordinator(false, true, true, true, false);
            setStaff(false, true, true, true, false);
            setRegistrar(false, true, true, true, false);
            setAttendeeFromJapanOrKorea(false, true, true, true, false);
        }
        else {
            setRegistrationType(1, true, true, true, false);
            setStudent(false, true, true, true, false);
            setTrialCoordinator(false, true, true, true, false);
            setStaff(false, true, true, true, false);
            setRegistrar(false, true, true, true, false);
            setAttendeeFromJapanOrKorea(false, true, true, true, false);
        }
    }, [trialCoordinator, student, staff, registrar, defaultUser, attendeeFromJapanOrKorea]);

    return null;
};

export default RegistrationTypeUpdater;
